import * as React from 'react';
import classnames from 'classnames';
import * as styles from './ImageWithText.module.scss';

export type ImageWithTextProps = {
    image: React.ReactNode;
    text: React.ReactNode;
    description: React.ReactNode;
    imagePosition: 'left' | 'right' | 'full';
    classes?: Partial<typeof styles>;
};

function ImageWithText({
    image,
    text,
    description,
    imagePosition = 'left',
    classes,
}: ImageWithTextProps): React.ReactElement {
    return (
        <div
            className={classnames(styles.root, classes?.root, {
                [styles.rightImage]: imagePosition === 'right',
                [styles.fullImage]: imagePosition === 'full',
            })}
        >
            <div
                className={classnames(
                    styles.imageWrapper,
                    classes?.imageWrapper,
                )}
            >
                <div className={classnames(styles.image, classes?.image)}>
                    {image}
                </div>
                <div
                    className={classnames(
                        styles.description,
                        classes?.description,
                    )}
                >
                    {description}
                </div>
            </div>
            <p className={classnames(styles.text, classes?.text)}>{text}</p>
        </div>
    );
}

export default ImageWithText;
